/*******************************************************
Close All Sub-Navigation Dropdown Menus
Shows or hides the navigation menus that appear below links in the section nav.
********************************************************/

export default function closeDropdownMenu() {

    // Hide all the sub nav groups
    $('.s-sub-nav__group, .section-sub-nav__group').addClass('hide');

    // Remove the 'open' class from all items
    $('.s-nav__item, .section-nav__item').removeClass('open');
}
